import "./style.css";
import { VStack } from "components/Stack";
import Card from "components/Card";
import finishSetup from "images/finish_setup.svg";

type Props = {
  onClick: () => void;
};

function FinishSetup(props: Props) {
  return (
    <Card className={"finish-container"}>
      <VStack align={"center"}>
        <img src={finishSetup} alt="content" />

        <div className={"finish-setup-content"}>
          Finish setting up your account to see recommended courses
        </div>

        <button className="button btn finish-btn mt-4" onClick={props.onClick}>
          Finish account setup
        </button>
      </VStack>
    </Card>
  );
}

export default FinishSetup;
